import { render, staticRenderFns } from "./product.vue?vue&type=template&id=5c2edd19&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2edd19')) {
      api.createRecord('5c2edd19', component.options)
    } else {
      api.reload('5c2edd19', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=5c2edd19&", function () {
      api.rerender('5c2edd19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/extended_info/product.vue"
export default component.exports